import loadOverlayStyle from "./LoadOverlay.module.scss";

type LoadOverlayProps = {
    children: React.ReactNode,
    loading: boolean
}

export const LoadOverlay = ({ loading, children }: LoadOverlayProps) => {
    return (
        <>
            {
                loading ?
                    <div className={loadOverlayStyle.curtain}>
                        <div className={loadOverlayStyle.ldsFacebook}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                    :
                    <>{children}</>
            }
        </>
    )
}